import StockLocatorSlider from "./views/detail/Slider";
import StockLocatorSimilar from "./views/Similar/Similar";
import Filter from "./views/Filter/Filter";
import WishCompare from "./views/WishCompare/WishCompare";
import Compare from "./views/Compare/Compare";
import CarChooser from "./views/CarChooser/CarChooser";
import StockLocatorDetail from "./views/detail/detail";
import StockLocatorList from "./views/list/list";
import StockLocatorZoom from "./views/detail/zoomer/zoomer";
import View360 from "./views/detail/view-360";
import FilterRent from "@modules/stock_locator/views/Filter/Filter.rent.js";
import PriceOffer from "@modules/stock_locator/views/PriceOffer/PriceOffer.js";

const StockLocator = {

	init: function() {
		WishCompare.init();
		StockLocatorDetail.init();

		new PriceOffer();

		this.el = $('[module="stock_locator"], [template="stock_locator"]');
		if(!this.el.length) return;

		StockLocatorSlider.init();
		StockLocatorZoom.init();
		StockLocatorList.init()
		Compare.init();
		CarChooser.init();
		Filter.init(this.el);
		View360.init();
	},

	Accordion: {
		init: function() {
			this.accordion = $('.locator.accordion');
			this.item = this.accordion.find('.item');
			this.head = this.item.find('.head');

			this.bind();
			this.toggleBody(this.accordion.find('.item.active'));
		},

		bind: function() {
			var self = this;
			this.head.on('click', function() {
				$(this).parent().toggleClass('active');
				self.toggleBody($(this).parent());
			});
		},

		toggleBody: function (elem) {
			elem.find('.body').stop().slideToggle();
		}
	},
};

export default StockLocator;
window.StockLocator = StockLocator;
